import * as Yup from "yup";
export const addtionOfSalaryLedger = Yup.object({
  sal_ldgr_desc: Yup.string().required("Salary Description is  required"),
});
